import { GrupoImunobiologicoEnum } from 'graphql/types.generated'

export const GRUPOS_IMUNOBILIOGICO_DESENVOLVIMENTO_INFANTIL = new Set([
  GrupoImunobiologicoEnum.DIFTERIA_TETANO_PERTUSIS_HEPATITE_B_HAEMOPHILUS_INFLUENZA_B,
  GrupoImunobiologicoEnum.POLIOMELITE,
  GrupoImunobiologicoEnum.SARAMPO_CACHUMBA_RUBEOLA,
  GrupoImunobiologicoEnum.PNEUMOCOCICA,
])

export const GRUPOS_IMUNOBILIOGICO_GESTANTE_PUERPERA = new Set([GrupoImunobiologicoEnum.DTPA])

export const GRUPOS_IMUNOBILIOGICO_PESSOA_IDOSA = new Set([GrupoImunobiologicoEnum.INFLUENZA])

export const GRUPOS_IMUNOBILIOGICO_SAUDE_MULHER = new Set([GrupoImunobiologicoEnum.HPV])
